import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UploadItem, UploadsState } from './chat.types.js';

export type { UploadItem, UploadsState };

const initialState: UploadsState = { items: [] };

const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    uploadStarted(state, action: PayloadAction<UploadItem>) {
      state.items.push(action.payload);
    },
    uploadProgress(state, action: PayloadAction<{ id: string; progress: number }>) {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) item.progress = action.payload.progress;
    },
    uploadDone(state, action: PayloadAction<{ id: string }>) {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        item.status = 'done';
        item.progress = 100;
      }
    },
    uploadFailed(state, action: PayloadAction<{ id: string; errorMessage: string }>) {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        item.status = 'error';
        item.errorMessage = action.payload.errorMessage;
      }
    },
    uploadRetried(state, action: PayloadAction<{ id: string }>) {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        item.status = 'uploading';
        item.progress = 0;
        item.errorMessage = undefined;
      }
    },
    uploadRemoved(state, action: PayloadAction<{ id: string }>) {
      state.items = state.items.filter((i) => i.id !== action.payload.id);
    },
    uploadsCleared(state) {
      state.items = state.items.filter((i) => i.status === 'uploading');
    },
  },
});

export const {
  uploadStarted,
  uploadProgress,
  uploadDone,
  uploadFailed,
  uploadRetried,
  uploadRemoved,
  uploadsCleared,
} = uploadsSlice.actions;

export default uploadsSlice.reducer;
